// Shared by the contact form and its API route, so keep this file free of
// anything browser-only.

export const CONTACT_TOPICS = [
    'Branding & identity',
    'Website',
    'Content & social',
    'Growth marketing',
    'Social Spark plan',
    'Web Launch plan',
    'Brand Kickstart plan',
    'Joining the team',
    'Something else'
] as const

export type ContactTopic = typeof CONTACT_TOPICS[number]

export const CONTACT_LIMITS = {
    name: 120,
    email: 200,
    phone: 40,
    message: 4000
}

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export const isContactTopic = (value: unknown): value is ContactTopic => {
    return typeof value === 'string' && (CONTACT_TOPICS as readonly string[]).includes(value)
}
